var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleLogo = function SvgGoogleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    fillRule: "evenodd",
    d: "M19.2 10.218c0-.68-.061-1.333-.174-1.96H10v3.706h5.158a4.4 4.4 0 0 1-1.913 2.893v2.404h3.097c1.813-1.668 2.858-4.125 2.858-7.043",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    fillRule: "evenodd",
    d: "M10 19.583c2.587 0 4.757-.858 6.342-2.322l-3.097-2.404c-.858.575-1.956.914-3.245.914-2.496 0-4.609-1.686-5.362-3.95H1.436v2.482A9.58 9.58 0 0 0 10 19.583",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    fillRule: "evenodd",
    d: "M4.638 11.82a5.8 5.8 0 0 1-.3-1.82c0-.632.108-1.246.3-1.82V5.695H1.436A9.6 9.6 0 0 0 .416 10c0 1.547.371 3.01 1.02 4.304z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    fillRule: "evenodd",
    d: "M10 4.228c1.407 0 2.67.484 3.663 1.433l2.749-2.748C14.752 1.366 12.583.417 10 .417a9.58 9.58 0 0 0-8.564 5.279L4.638 8.18C5.39 5.914 7.504 4.229 10 4.229",
    clipRule: "evenodd"
  })));
};
export default SvgGoogleLogo;